export default {
  props: {
    /**
      * Orientation of component (landscape, portrait)
      */
    orientation: {type: String, default: 'landscape'}
  }
};
